import { UCCViewParams } from '@lk/api'
import { createAsyncThunk } from '@reduxjs/toolkit'
import { ThunkApi } from '../index.d'

export const uccViewFindChecks = createAsyncThunk<any, Partial<UCCViewParams>, ThunkApi>(
  '[UCC_VIEW] FIND_CHECKS',
  async (params, { extra, rejectWithValue }) => {
    const result = await extra.api.ucc.view('findchecks', params)

    if (result.success) {
      return result.data
    }

    return rejectWithValue(result.error)
  },
)

export const uccViewFindPayments = createAsyncThunk<any, Partial<UCCViewParams>, ThunkApi>(
  '[UCC_VIEW] FIND_PAYMENTS',
  async (params, { extra, rejectWithValue }) => {
    const result = await extra.api.ucc.view('findpayments', params)

    if (result.success) {
      return result.data
    }

    return rejectWithValue(result.error)
  },
)

export const uccViewLastPayments = createAsyncThunk<any, Partial<UCCViewParams>, ThunkApi>(
  '[UCC_VIEW] LAST_PAYMENTS',
  async (params, { extra, rejectWithValue }) => {
    const result = await extra.api.ucc.view('lastpayments', params)

    if (result.success) {
      return result.data
    }

    return rejectWithValue(result.error)
  },
)

export const uccViewQueue = createAsyncThunk<any, Partial<UCCViewParams>, ThunkApi>(
  '[UCC_VIEW] QUEUE',
  async (params, { extra, rejectWithValue }) => {
    const result = await extra.api.ucc.view('queue', params)

    if (result.success) {
      return result.data
    }

    return rejectWithValue(result.error)
  },
)
